import Settings from "Data/Settings";
import { Sine, TimelineLite, TweenMax } from "gsap";
import * as HLF from "html-living-framework";
import * as Topics from "Data/Topics";
import * as SFX from "Data/SoundEffect";
import * as VO from "Data/VoiceOver";
import * as Constants from "Data/Constants";
import {DWELL_DURATION} from "Data/Constants";
import { Button } from "GameObjects/UI/Button";
import { LayoutButton } from "GameObjects/UI/LayoutButton";

export class DwellToggleButton extends LayoutButton {

    public readonly onTexture: string = "cyberchase-splashscreen-dwell-on-btn";
    public readonly offTexture: string = "cyberchase-splashscreen-dwell-off-btn";

    public constructor() {
        super(()=>this.onDwellButtonPressed(), undefined as any as string, SFX.UI_CLICK);
        if (Settings.useDwellActivation) {
            this.hoverVO = VO.BUTTON_DWELL_HOVER_ON;
        }
        else {
            this.hoverVO = VO.BUTTON_DWELL_HOVER_OFF;
        }
    }

    protected onPointerOver(pEvent: PIXI.InteractionEvent): void {
        super.onPointerOver(pEvent);
        this.beginDwell();
    }

    protected onPointerOut(pEvent: PIXI.InteractionEvent): void {
        super.onPointerOut(pEvent);
        this.cancelDwell();
    }

    protected onDwellButtonPressed(): void {
        Settings.useDwellActivation = !Settings.useDwellActivation;
        if (Settings.useDwellActivation) {
            HLF.Application.instance.voiceover.playVO(VO.DWELL_ON, HLF.PlayMode.New);
        }
        else {
            HLF.Application.instance.voiceover.playVO(VO.DWELL_OFF, HLF.PlayMode.New);
        }
    }

    protected onSettingsChanged(pTopic: typeof Topics.SETTINGS_CHANGED, pSettings: Readonly<typeof Settings>): void {
        super.onSettingsChanged(pTopic, pSettings);
        if (Settings.useDwellActivation === true) {
            this._image!.texture = HLF.PixiUtils.getTexture(this.onTexture);
            this.hoverVO = VO.BUTTON_DWELL_HOVER_ON;
        }
        else {
            this._image!.texture = HLF.PixiUtils.getTexture(this.offTexture);
            this.hoverVO = VO.BUTTON_DWELL_HOVER_OFF;
        }
    }
}
